import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=bdb0d73e"
import script from "./Tv.vue?vue&type=script&lang=ts"
export * from "./Tv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports